import { TypePermissionEntity } from "@/data/default/types/enumPermission";
import { RouteConfig } from "vue-router";
import RouterDirector from "@/data/default/types/RouterDirector";

const builder = RouterDirector.makeRouterWithPermission({
  name: "solicitarVisitaPreventiva",
  permissionEntity: TypePermissionEntity.SOLICITACAO_VISITA_PREVENTIVA,
  componentRoot: () => import("@/screens/default/visitaPreventiva/Index.vue"),
  componentList: () => import("@/screens/default/visitaPreventiva/List.vue"),
  componentSave: () => import("@/screens/default/visitaPreventiva/Save.vue")
});

export const Router: RouteConfig[] = [builder.getRootRoute()];

export const routes = builder.getRouteNames();
